import { render, staticRenderFns } from "./perfessionalDesign.vue?vue&type=template&id=418c0d6f&scoped=true"
import script from "./perfessionalDesign.vue?vue&type=script&lang=js"
export * from "./perfessionalDesign.vue?vue&type=script&lang=js"
import style0 from "./perfessionalDesign.vue?vue&type=style&index=0&id=418c0d6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c0d6f",
  null
  
)

export default component.exports